import * as React from 'react';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { InquiryTypes } from 'src/Library/Types';

interface IProps extends CommonProps {
  allowedIncoterm: string[];
}

const IncotemSelect = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    placeholder,
    allowedIncoterm,
  } = props;

  const renderIncotermOptions = () => {
    return allowedIncoterm?.map((incoterm) => <Select.Option
      key={incoterm}
    >
      {incoterm}
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    value={value}
    disabled={disabled}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    placeholder={placeholder || 'Select Incoterm'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderIncotermOptions()}
  </Select>;
};

export default React.memo(IncotemSelect);
